import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=4b2bc6d4"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=4b2bc6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports